function terminate()
{
  hideAll();
  displayText("content",textScreens['warnings'][language]['resolution']);
}

function firefoxWarning()
{
  hideAll();
  displayText("content",textScreens['warnings'][language]['firefox']);
}